import Swal from "sweetalert2";
import {
  request_assign_member_access,
  request_delete_organization_member,
} from "./organization_members_api";
import {
  get_initials,
  get_member_permission_ids,
  get_member_profile_picture,
} from "./organization_members_helpers";

export default {
  remove_organization_member(member) {
    if (!this.get_company_id()) {
      this.show_error("Organisation id is missing. Please refresh and try again.");
      return;
    }

    Swal.fire({
      title: "Remove member?",
      text: `${member.first_name} ${member.last_name} will lose organisation access.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Remove",
    }).then((result) => {
      if (!result.isConfirmed) return;
      request_delete_organization_member({
          organization_id: this.get_company_id(),
          member_id: member.id,
        })
        .then((response) => {
          if (response?.status === "success") {
            this.destroy_members_datatable();
            this.organization_members = this.organization_members.filter((item) => Number(item.id) !== Number(member.id));
            this.refresh_members_datatable();
            this.show_success("Member removed");
            return;
          }
          this.show_error(response?.message || "Could not remove organisation member.");
        })
        .catch((xhr) => this.show_error(xhr?.responseJSON?.message || "Could not remove organisation member."));
    });
  },
  open_manage_member(member) {
    this.selected_member = member;
    this.member_access_errors = {};
    this.member_access = {
      permission_ids: this.get_member_permission_ids(member),
    };
    $("#manage_organization_member_modal").modal("show");
  },
  save_member_access() {
    if (!this.selected_member) return;
    this.is_saving_access = true;
    this.member_access_errors = {};

    const payload = {
      organization_id: this.get_company_id(),
      member_id: this.selected_member.id,
      user_id: this.selected_member.user?.id || this.selected_member.id,
      permission_ids: this.member_access.permission_ids,
    };

    request_assign_member_access(payload)
      .then((response) => {
        if (response?.status !== "success") {
          this.member_access_errors.form = response?.message || "Could not update member access.";
          return;
        }
        this.show_success("Member access updated");
        $("#manage_organization_member_modal").modal("hide");
        this.fetch_organization_members();
      })
      .catch((xhr) => {
        this.member_access_errors.form = xhr?.responseJSON?.message || "Could not update member access.";
      })
      .finally(() => {
        this.is_saving_access = false;
      });
  },
  get_member_permission_ids(member) {
    return get_member_permission_ids(member);
  },
  get_initials(member) {
    return get_initials(member);
  },
  get_member_profile_picture(member) {
    return get_member_profile_picture(member);
  },
  set_invite_error(message) {
    if (String(message).toLowerCase().includes("email")) {
      this.invite_errors.email = message;
      return;
    }
    this.invite_errors.form = message;
  },
  set_new_user_error(message) {
    if (String(message).toLowerCase().includes("email")) {
      this.new_user_errors.email = message;
      return;
    }
    if (String(message).toLowerCase().includes("phone")) {
      this.new_user_errors.phone_number = message;
      return;
    }
    this.new_user_errors.form = message;
  },
  show_success(title) {
    Swal.fire({
      icon: "success",
      title,
      showConfirmButton: false,
      timer: 1200,
      position: "bottom-end",
      toast: true,
    });
  },
  show_error(message) {
    Swal.fire({
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
      position: "bottom-end",
      toast: true,
    });
  },
};
